import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "visibility"
    }}>{`visibility`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v3.0`}</p>
    <p>{`Determines if an element is visible. Supports `}<inlineCode parentName="p">{`visible`}</inlineCode>{` and `}<inlineCode parentName="p">{`hidden`}</inlineCode>{`. Unlike `}<inlineCode parentName="p">{`display: none`}</inlineCode>{`, a hidden element still takes up the same space in the surrounding layout.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/visibility"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/visibility`}</a></p>
    <p><strong parentName="p">{`Example`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    visibility: hidden;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      